import React from 'react';
import {connect} from 'react-redux';
import * as Constants from "../../Common/constants";
import SlidingPane from 'react-sliding-pane';
import { ReportFeedWidget } from '../ReportFeedWidget/ReportFeedWidget';
import { LastReportWidget } from '../LastReportWidget/LastReportWidget';
import { LeaderboardWidget } from '../LeaderboardWidget/LeaderboardWidget';
import Help from './Help.js';


 class Footernav extends React.Component {
    constructor(props) {

        super(props);
        this.handleToggleMenu = this.handleToggleMenu.bind(this);
        this.handleSlideMenu = this.handleSlideMenu.bind(this);
        this.closeMenu = this.closeMenu.bind(this);
        this.state = { 
            clicked: false,
            change: false,
            sidebarOpen: false,
            data: null, serverErrors: {} }
    }
   
    componentWillMount() {

    }

    componentDidMount() {
      console.log("didmount!");
    }

    componentWillReceiveProps(nextProps) {
       
    }

    shouldComponentUpdate() {
        return true;
    }

    componentWillUpdate() {
    }

    componentDidUpdate() {
    }

    componentWillUnmount() {
    }


    onChange(e) {

    }
    handleToggleMenu(){
        this.setState({ 
            change : !this.state.change,
            sidebarOpen: !this.state.sidebarOpen });
            
    }
    closeMenu(){
        console.log("closeMenu");
        this.setState({ 
            change : false,
            sidebarOpen: false });
    }

     render() {
         let sidebarClassname = this.state.sidebarOpen ? 'sidebar open' : 'sidebar';
         let contentClassname = this.state.sidebarOpen ? 'content open' : 'content';
         //let logoImage = Constants.IMAGE_SERVER+ "/images/snapshot-logo-long.png";
         let logoImage = Constants.IMAGE_SERVER + "/images/GolfSnapshot_liggande_svart.png";
         const change = this.state.change
         console.info('Footernav - render called.', this.props);
         return (<div className="headerContainer">
             <div className="logowrapper"><img className='logo' /*src={logoImage}*/ /></div>
             <div className="barWrapper">
                 <div className="hamburgerMenu" onClick={this.handleToggleMenu}

                     className={change ? 'change' : ''}>
                     <div className="bar1"></div>
                     <div className="bar2"></div>
                     <div className="bar3"></div>
                 </div>
             </div>
             <div className={sidebarClassname} onClick={this.closeMenu}>
                 {<Help />}
             </div>
         </div>);
        
    }

    handleSlideMenu(){
        this.setState({
            clicked: true
          });
      
    }
}

const mapStateToProps = state => ({
    lastitem: state.sidebarOpen
    
    
 });
 
 /**
 * Import action from dir action above - but must be passed to connect method in order to trigger reducer in store
 * @type {{UserUpdate: UserUpdateAction}}
 */
 const mapActionsToProps = {
   
 };
 export default connect(mapStateToProps, mapActionsToProps)(Footernav);

/*<div className="hamburgerMenu" onClick={() => this.setState({ change: true })}
                onAnimationEnd={() => this.setState({ change: false })}
                className={change ? 'change' : ''}>></div>*/


// WEBPACK FOOTER //
// ./src/Components/Footernav/Footernav.js